export const AUTH_LOADING_STATE = {
    AUTHENTICATION_LOADING: "AUTHENTICATION_LOADING" as "AUTHENTICATION_LOADING",
    FETCH_ME: "FETCH_ME" as "FETCH_ME",
    RESET_PASSWORD_LOADING: "RESET_PASSWORD_LOADING" as "RESET_PASSWORD_LOADING",
    CONFIRM_PASSWORD_RESET_LOADING: "CONFIRM_PASSWORD_RESET_LOADING" as "CONFIRM_PASSWORD_RESET_LOADING"
}